import './ep-teaser.scss';

class EpTeaser {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-epteaser',
            mediaAttr: 'media',
            elementAttr: 'element',
            footerAttr: 'footer',
            replayAttr: 'replay',
            soundAttr: 'sound',
            iconAttr: 'icon',
            eventScroller: null
        };

        this.settings = Object.assign({}, defaults, options);

        this.$epTeaser = element;
        this.$epElements = this.$epTeaser.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.elementAttr + '"]');
        this.$epMedia = this.$epTeaser.querySelector('[' + this.settings.initAttr + '="' + this.settings.mediaAttr + '"]');
        this.$epReplayButton = this.$epTeaser.querySelector('[' + this.settings.initAttr + '="' + this.settings.replayAttr + '"]');
        this.$epSoundButton = this.$epTeaser.querySelector('[' + this.settings.initAttr + '="' + this.settings.soundAttr + '"]');
        this.$epFooter = this.$epTeaser.querySelector('[' + this.settings.initAttr + '="' + this.settings.footerAttr + '"]');
        this.revealTimeout = null;
        this.videoPlaying = false;
        this.muted = true;
        this.$nextElement = this.$epTeaser.nextElementSibling;

        if (this.$epElements.length === 0) {
            console.error('no elements found with ' + this.settings.initAttr + '="' + this.settings.elementAttr + '"');
            return;
        }

        if (this.$epMedia === null) {
            console.error('no element found with ' + this.settings.initAttr + '="' + this.settings.mediaAttr + '"');
            return;
        }

        if (this.$epFooter === null) {
            console.error('no element found with ' + this.settings.initAttr + '="' + this.settings.footerAttr + '"');
            // return;
        }
    }

    initialize () {
        this.$navigation = document.createElement('nav');
        this.$navigation.classList.add('ep-teaser__reveal-navigation');

        const $navigationInner = document.createElement('div');
        $navigationInner.classList.add('ep-teaser__reveal-navigationinner');

        for (let i = 0; i < this.$epElements.length; i++) {
            const $element = this.$epElements[i];
            const $icon = $element.querySelector('[' + this.settings.initAttr + '="' + this.settings.iconAttr + '"]');

            $element.setAttribute('index', i);

            if ($icon !== null) {
                $icon.setAttribute('index', i);
                $navigationInner.appendChild($icon);
            }
        }

        this.$navigation.appendChild($navigationInner);
        this.$epFooter.appendChild(this.$navigation);

        this.$epTeaser.classList.add('is--animating');

        this.$previousElement = this.$epTeaser.previousElementSibling;

        if (this.$previousElement === null) { // is first element
            if (this.$epMedia.readyState > 3) {
                this.$epMedia.play();
                this.$epMedia.setAttribute('playing', true);
            } else {
                this.$epMedia.addEventListener('canplaythrough', () => {
                    this.$epMedia.play();
                    this.$epMedia.setAttribute('playing', true);
                });
            }
        }

        this.setEvents();
    }

    setActiveReveal ($element) {
        let currentIndex = 0;

        if ($element) {
            currentIndex = $element.getAttribute('index');
        }

        for (let i = 0; i < this.$epElements.length; i++) {
            const $epElement = this.$epElements[i];

            $epElement.classList.remove('is--active');
        }

        if (currentIndex !== 0 || this.videoPlaying === false) {
            clearTimeout(this.revealTimeout);
            this.revealTimeout = window.setTimeout(() => {
                this.$epElements[currentIndex].classList.add('is--active');
            }, 250);
        }
    }

    setEvents () {
        this.$epMedia.addEventListener('ended', () => {
            this.$epTeaser.classList.add('is--media-ended');
            this.$epMedia.setAttribute('playing', false);
            this.videoPlaying = false;
            this.setActiveReveal();
        });

        this.$epMedia.addEventListener('play', () => {
            const $active = this.$epTeaser.querySelector('.is--active');

            if ($active !== null) {
                $active.classList.remove('is--active');
            }
            this.$epTeaser.classList.remove('is--media-ended');
            this.videoPlaying = true;
        });

        const $navigationElements = this.$navigation.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.iconAttr + '"]');

        for (let i = 0; i < $navigationElements.length; i++) {
            const $navigationElement = $navigationElements[i];

            if (!window.Modernizr.csshover) {
                $navigationElement.addEventListener('mouseover', () => {
                    this.setActiveReveal($navigationElement);
                });

                $navigationElement.addEventListener('click', (e) => {
                    e.preventDefault();
                });
            } else {
                $navigationElement.addEventListener('mouseenter', () => {
                    this.setActiveReveal($navigationElement);
                });

                $navigationElement.addEventListener('mouseleave', () => {
                    this.setActiveReveal();
                });
            }
        }

        if (this.$epReplayButton !== null) {
            this.$epReplayButton.addEventListener('click', () => {
                this.$epMedia.play();
            });
        }

        if (this.$epSoundButton !== null) {
            this.$epSoundButton.addEventListener('click', () => {
                if (this.$epMedia.muted === true) {
                    this.$epMedia.muted = false;
                    this.$epSoundButton.classList.add('has--volume');
                } else {
                    this.$epMedia.muted = true;
                    this.$epSoundButton.classList.remove('has--volume');
                }
            });
        }

        const eventScroller = this.settings.eventScroller;
        if (this.$nextElement !== null && eventScroller !== null) {
            eventScroller.customFunctions.push(() => {
                const onScreenStatus = eventScroller.onScreen(this.$nextElement, 0, false);

                if (onScreenStatus === true) {
                    this.$epMedia.pause();
                    this.$epTeaser.classList.add('is--hiding');
                } else {
                    this.$epMedia.play();
                    if (this.$epTeaser.classList.contains('is--hiding')) {
                        this.$epTeaser.classList.remove('is--hiding');
                    }
                }
            });
        }
    }
}

export { EpTeaser };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $epTeasers = $context.querySelectorAll('[data-epteaser="root"]');

        if ($epTeasers.length > 0) {
            for (let i = 0; i < $epTeasers.length; i++) {
                const $epTeaser = new EpTeaser($epTeasers[i], {
                    eventScroller: window.eventScroller
                });
                $epTeaser.initialize();
            }
        }
    }
});
